import {http} from "Services/Http/HttpClient";

export const updateInscriptionActivitySpecialNeed = async (id: string, body: any): Promise<any> => {
    return await http.patch('/inscriptions/special-needs/admin/' + id, body)
}
